import { jsx as _jsx } from "react/jsx-runtime";
import React, { Component } from 'react';
import amplitude from 'amplitude-js';
import AutoFixBanner from './AutoFixBanner';
import { withAutoFixModal } from './AutoFixModal';
class AutoFixes extends Component {
    generateAutoFixIssue(filesByExtensions, fileExtension, extraIssuesByExtensions) {
        const { reportsFiles } = this.props;
        const files = Object.keys(filesByExtensions)
            // @ts-expect-error TS7053: Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'FilesByExtension'.
            .filter((file) => file === fileExtension && filesByExtensions[file].length > 0)
            // @ts-expect-error TS7053: Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'FilesByExtension'.
            .map((extension) => filesByExtensions[extension]);
        // @ts-expect-error TS7053: Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'FilesByExtension'.
        let issueCount = extraIssuesByExtensions[fileExtension];
        issueCount += Object.values(reportsFiles).reduce((acc, file) => {
            // @ts-expect-error TS7053: Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'FilesByExtension'.
            return filesByExtensions[fileExtension].includes(file.filePath)
                ? acc + file.errorCount + file.warningCount
                : acc;
        }, 0);
        return {
            isError: false,
            options: {
                files: files,
                issuesCount: issueCount,
            },
            autoFix: true,
        };
    }
    render() {
        const { match, commit, filesByExtensions, extraIssuesByExtensions, onShowDetailClick } = this.props;
        const autoFixIssueJS = this.generateAutoFixIssue(filesByExtensions, 'js', extraIssuesByExtensions);
        const autoFixIssuePHP = this.generateAutoFixIssue(filesByExtensions, 'php', extraIssuesByExtensions);
        const eventData = {
            commitHash: commit.hash,
            commitId: commit.id,
            repositoryFullname: `${match.params.owner}/${match.params.repository}`,
        };
        return Object.keys(filesByExtensions).map((extension) => {
            // @ts-expect-error TS7053: Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'FilesByExtension'.
            const showMessage = !!(filesByExtensions[extension].length
                ? extension === 'php'
                    ? autoFixIssuePHP.options.issuesCount
                    : autoFixIssueJS.options.issuesCount
                : false);
            //@ToDo: Add Smartlook event
            if (showMessage) {
                amplitude.getInstance().logEvent('show-quick-fixes-message-' + extension, eventData);
                const issue = extension === 'php' ? autoFixIssuePHP : autoFixIssueJS;
                const autoFix = issue.autoFix;
                const showAutoFix = autoFix && issue.options;
                if (!showAutoFix) {
                    return null;
                }
                return (_jsx("div", { className: "mt-4", children: _jsx(AutoFixBanner, { options: issue.options, extension: extension, handleShowDetail: onShowDetailClick }) }, 'show-auto-fixes-message-' + extension));
            }
            // @ts-expect-error TS7053: Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'FilesByExtension'.
            if (filesByExtensions[extension].length) {
                // Is this really helping us figure out if the user used the auto fix from last commit?
                amplitude.getInstance().logEvent('dont-show-quick-fixes-message-' + extension, eventData);
            }
            return null;
        });
    }
}
export default (withAutoFixModal(AutoFixes));
